import { render, staticRenderFns } from "./CompaignDetails.vue?vue&type=template&id=08be6fc4&scoped=true&"
import script from "./CompaignDetails.vue?vue&type=script&lang=ts&"
export * from "./CompaignDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CompaignDetails.vue?vue&type=style&index=0&id=08be6fc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be6fc4",
  null
  
)

export default component.exports